import React from 'react';
import { LogOut, Shield } from 'lucide-react';

const UserProfile = ({ user, onLogout, onUpgradeToGoogle }) => {
  const getInitials = (name) => {
    if (!name) return 'G';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  const isGuest = user?.userType === 'guest' || !!user?.tempId;

  return (
    <div className="user-profile">
      <div className="user-avatar">
        {user?.picture ? (
          <img src={user.picture} alt={user.name} className="avatar-img" />
        ) : (
          getInitials(user?.name || 'Guest')
        )}
      </div>
      
      <div className="user-info">
        <div className="user-name">
          {user?.name || 'Guest'}
          {isGuest && <span className="guest-badge">guest</span>}
        </div>
        <div className="user-type">
          {isGuest ? 'Temporary session' : user?.email}
        </div>
      </div>
      
      <div className="user-actions">
        {isGuest && (
          <div className="action">
            <button 
              onClick={onUpgradeToGoogle}
              className="btn btn-upgrade"
              title="Save permanently"
            >
              <Shield size={16} />
            </button>
            <div className="action-label action-save">Save</div>
          </div>
        )}
        <div className="action">
          <button 
            onClick={onLogout}
            className="btn btn-logout"
            title={"Sign out"}
          >
            <LogOut size={16} />
          </button>
          <div className="action-label action-logout">Log out</div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
